"use client"
import { Button } from "@/components/themes/ui/button"
import { ChevronLeft, Search } from "lucide-react"
import { useRouter } from "next/navigation"
// import SearchBar from "./SearchBar"
import { useEffect, useRef } from "react"
import SearchBar from "./SearchBar"

interface SearchOverlayProps {
  isOpen: boolean
  onClose: () => void
}

export function SearchOverlay({ isOpen, onClose }: SearchOverlayProps) {
  const router = useRouter()
  const searchBarRef = useRef<{ focusInput: () => void } | null>(null);

  const handleNavigate = (path: string) => {
    router.push(path)
    onClose() // Close the overlay after navigation
  }

  // Focus the search input when the overlay opens
  useEffect(() => {
    if (isOpen && searchBarRef.current) {
      setTimeout(() => {
        searchBarRef.current?.focusInput();
      }, 0);
    }
  }, [isOpen]);

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col h-screen overflow-y-auto">
      <div className="flex items-center bg-gray-100">
        <Button variant="ghost" size="icon" onClick={onClose} className="mr-2">
          {/* <ChevronLeft size={40} className="" /> */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-chevron-left-icon lucide-chevron-left !w-[24px] !h-[24px]"><path d="m15 18-6-6 6-6" /></svg>
          <span className="sr-only">Back</span>
        </Button>

        <div className="relative flex items-center flex-1 bg-gray-100 rounded-lg px-2">
          <Search className="h-5 w-5 text-gray_text mr-2 cursor-pointer absolute top-5 z-20 right-4" />
          <SearchBar ref={searchBarRef} isMobile={false} onNavigate={handleNavigate} />
        </div>
      </div>
    </div>
  )
}